import { Group } from "@visx/group";
import { ChartMarker } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/AreaChart/components/markerLayer/ChartMarker";
import { buildMarkersToRender } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/AreaChart/components/markerLayer/utils";
import { CHART_CONFIG } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/AreaChart/constants";
import { TransportNeedGraphPoint } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/AreaChart/types";
import { AreaChartMarkers } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/AreaChart/utils";
import { FC, useMemo } from "react";

interface MarkerLayerProps {
  markers: AreaChartMarkers;
  dateScale: (d: Date) => number;
  valueScale: (v: number) => number;
  xMax: number;
  yMax: number;
  hoverX?: number | null;
  hoverData?: TransportNeedGraphPoint | null;
  points: TransportNeedGraphPoint[];
}

export const MarkerLayer: FC<MarkerLayerProps> = ({
  markers,
  dateScale,
  valueScale,
  xMax,
  yMax,
  hoverX,
  hoverData,
  points,
}) => {
  const markersToRender = useMemo(
    () =>
      buildMarkersToRender({
        markers,
        dateScale,
        valueScale,
        hoverX,
        hoverData,
        points,
      }),
    [markers, dateScale, valueScale, hoverX, hoverData, points],
  );

  const badgeY = yMax + CHART_CONFIG.badgePadding;

  return (
    <Group>
      {markersToRender.map((m) => (
        <g key={m.key}>
          <ChartMarker marker={m} xMax={xMax} badgeY={badgeY} />
        </g>
      ))}
    </Group>
  );
};
